/* eslint-disable camelcase */
/**
 * Configures the webpack public path based on the current URL.
 *
 * This function dynamically adjusts the webpack public path by examining the current URL.
 * It establishes the path up to the last occurrence of '/c/' (if present), or the entire URL otherwise.
 * The resulting path is then assigned to the __webpack_public_path__ global variable.
 * The '/c/' segment denotes a specific card path within the published story URL.
 *
 * Reference: {@link https://webpack.js.org/guides/public-path/#on-the-fly}
 */
function setPublicPath() {
	if (process.env.NODE_ENV !== 'development' && process.env.IS_ADMIN !== '1') {
		const { pathname, origin } = window.location;
		const endIndex = pathname.indexOf('/c/');
		const path = endIndex === -1 ? pathname : pathname.slice(0, endIndex);
		// @ts-ignore
		__webpack_public_path__ = `${origin}${path.endsWith('/') ? path : `${path}/`}`;
	}
}

setPublicPath();

export default setPublicPath;
